<template>
  <div>
    <Stretch v-show="loadingPage">Carregando...</Stretch>

    <div v-if="naoEncontradoMeusLotes">
      <nao-encontrado :leilaoId="leilao.id" :cookie="cookie"></nao-encontrado>
    </div>

    <div v-show="!loadingPage && !naoEncontradoMeusLotes">
      <bread-crumb :categorialeilao="leilao.categorialeilao" :nomeLeilao="leilao.nm"></bread-crumb>
      <header-disputa :leilaoid="leilaoId" :lotes="lotes" :dadosLeilao="dadosLeilao"></header-disputa>
      <mensagem-box :message="message" :liberado="liberado" :usuario="usuario"></mensagem-box>

      <Stretch v-show="loadingRefresh">Carregando...</Stretch>
      <div class="btn__meus-lotes" v-show="!firstLoadMeusLotes && !loadingRefresh">
        <router-link :to="previous()" class="back__lista-lotes">Auditório do leilão</router-link>
        <div @click="refreshPage" class="refresh-btn fa fa-refresh" title="Atualizar todos os lotes"></div>
      </div>

      <transition name="fade">
        <ul id="grid" class="products-grid columns4" v-show="!firstLoadMeusLotes && !loadingRefresh">
          <li v-for="(lote, idx) in lotes" :key="lote.id" class="lote-item">
            <card :leilao="leilaoSemFirebase"
                  :dados="lote"
                  :liberado="liberado"
                  :automatico="fechamento"
                  :usuarioid="usuario.id"
                  :intermediarios="intermediarios"
                  :statusleilao_id="leilaoSemFirebase.statusleilao_id"
                  :countLances="countLances[idx]"
                  :paramsite_proposta="paramsite_proposta"
                  @refresh-dados-gerais="refreshDadosGerais">
            </card>
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>
<script>
// PLUGIN COMPONENTS
import Paginate from 'vuejs-paginate'
import {Stretch} from 'vue-loading-spinner'
import {Carousel, Slide} from 'vue-carousel';

// LAYOUT COMPONENTS
import Card from '@/components/shared/Card'
import BreadCrumb from '@/components/shared/BreadCrumb'
import BotoesRotas from '@/components/shared/BotoesRotas'
import NaoEncontrado from '@/components/shared/NaoEncontrado'
import HeaderDisputa from '@/components/shared/HeaderDisputa'
import MensagemBox from '@/components/shared/MensagemBox'
import MensagemBoxLeilao from '@/components/shared/MensagemBoxLeilao'

export default {
  name: 'MeusLotes',
  props: ["dadosLeilao"],
  components: {
    BreadCrumb,
    Card,
    Stretch,
    Paginate,
    Carousel,
    Slide,
    BotoesRotas,
    NaoEncontrado,
    HeaderDisputa,
    MensagemBox,
    MensagemBoxLeilao
  },
  data() {
    return {
      countLances: [],
      leilaoId: this.$route.params.id,
      leilao: {},
      lotes: [],
      visitas: [],
      lotesAcompanhar: [],
      fechamento: false,
      leilaoSemFirebase: [],
      intermediarios: null,
      paramsite_proposta: [],
      config_leiloeiro: [],
      dados_condicao: [],
      dadosRequisicao: {isLogado: false, countLote: 0},
      usuario: {
        id: null,
        isFavorito: false,
        interesse: []
      },
      filtros: [],
      errors: [],
      value_video: null,
      loadingPage: true,
      loadingRefresh: false,
      naoEncontradoMeusLotes: false,
      firstLoadMeusLotes: true,
      liberado: false,
      parametrosFiltro: '',
      refreshMeusLotes: null,
      refreshCountMeusLotes: 30000,
      cookie: true,
      message: '',
      salaDisputa: null,
      lotesStatusReference: [],
      lotesLanceReference: [],
      lotesIncrementoReference: [],
      lotesDtfechamentoReference: []
    }
  },
  methods: {
    previous() {
      return `/leilao/index/leilao_id/${this.leilaoId}`;
    },

    loadMsg() {
      // VERIFICA STATUS MENSAGEM
      if (this.leilao.statusleilao_id == 1) { //Core_Resource_Statusleilao::FISICO
        this.message = 'Leilão presencial sem participação online.'
        this.liberado = false
      } else if (this.leilao.statusmontagem_id !== 3) { //Core_Resource_Statusmontagem::LISTA_COMPLETO
        if (this.leilao.statusmontagem_id == 5) { //Core_Resource_Statusmontagem::SUSPENSO
          this.message = 'Leilão suspenso'
          this.liberado = false
        } else {
          this.message = 'Leilão ainda não liberado para lances.'
          this.liberado = false
        }
      } else if (this.usuario.id !== null) {
        if (this.usuario.statusliberacaoonline_id !== 3) {
          this.message = this.usuario.nm_statusliberacaomensagem
          this.liberado = false
        } else if (this.dados_condicao.aceitou_condicao == false) {
          this.message = `
                        <a style="margin-left: 10px;" title="Condições de Venda" href="javascript:void(0)" onclick="openCondicoes('/leilao/condicoesdevenda?leilao_id=${this.leilao.id}');">
                            Clique aqui para aceitar as condições de venda.
                        </a>
                    `
          this.liberado = false
        } else {
          this.message = this.usuario.nm_statusliberacaomensagem
          this.liberado = true
        }
      } else {
        this.message = '<a href="/index/login" style="color: white">Usuário não logado, para iniciar os lances é preciso estar logado. Clique aqui para fazer login.</a>'
        this.liberado = false
      }
    },

    /* atualiza lotes */
    async refreshLotes() {
      var db = this.firebase_db;
      var self = this;

      try {
        if (this.lotesAcompanhar.length > 0) {
          var Promise = this.$root.bluebird;

          const lotes = await Promise.map(this.lotesAcompanhar, function (lote) {
            return db.ref(`/lote/${self.leilaoId}`).child(lote).once('value');
          });

          self.lotes = lotes.map(lote => lote.val());

          await self.saladisputa.ordenaLotesPorSeq(self.lotes);
          await self.saladisputa.observaLotesStatusLance(self.lotes);
          await self.saladisputa.configuraFavoritos();
          await self.saladisputa.configuraVisitas();
        } else {
          self.naoEncontradoMeusLotes = true;
        }
      } catch (e) {
        console.error("Erro ao atualizar lotes:", e);
      } finally {
        self.loadingPage = false;
        self.loadingRefresh = false;
        self.firstLoadMeusLotes = false;
      }
    },

    refreshDadosGerais() {
      const hostName = location.protocol + "//" + window.HOSTNAME;

      fetch(`${hostName}/leilao/get-dados-gerais?leilao_id=${this.leilaoId}`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Erro ao obter dados gerais: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          this.usuario = data.usuario;
          this.visitas = data.visitas;
          // Houve mudança nos favoritos, refresh lotes novamente
          this.lotesAcompanhar = this.usuario.interesse;
          this.refreshLotes();

          if (self.usuario.interesse && self.usuario.interesse.length > 0) {
            self.$emit('update-interesse', self.usuario.interesse);
          }
        })
        .catch(error => {
          console.error("Erro ao atualizar dados gerais:", error.message);
        });
    },

    refreshPage(ev) { // REFRESH
      this.loadingRefresh = true
      this.refreshLotes()
    },
    refreshFirebase() {

    }
  },
  watch: {
    'dadosLeilao'(novo, ant) {
      this.leilao = this.dadosLeilao
    }
  },
  created() {
    this.leilao = this.dadosLeilao
    this.saladisputa = new window.saladisputa(this)

    clearInterval(window.INTERVALO_BUSCA)
    clearInterval(window.INTERVALO_CATEGORIA)

    this.loadingPage = true

    this.$on('dados-gerais', function (data) {
      this.config_leiloeiro = data.config_leiloeiro
      this.dados_condicao = data.dados_condicao
      this.usuario = data.usuario
      this.lotesAcompanhar = this.usuario.interesse
      this.dadosRequisicao.isLogado = this.usuario.id !== null ? true : false
      this.visitas = data.visitas

      this.loadMsg()
      this.refreshLotes()

      // isLogado ?
      if (this.usuario.id !== null) {
        sessionStorage.setItem('isLogado', this.usuario.id !== null ? true : false)
      }
    })

    this.$on('favoritoModificado', function (_self) {
      this.refreshDadosGerais()
    })

    this.cookie = this.$root.cookieAtivo
    this.$root.MensagemBrowserCookie()
  }
}
</script>

<style>
.btn__meus-lotes {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px auto;
}

.back__lista-lotes {
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 8px;
  width: 200px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}

.back__lista-lotes:hover {
  background: #dbdbdb;
  color: #535353 !important;
  text-decoration: none;
}

.products-grid {
  margin: 20px -10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/MeusLotes.vue